
define( 'system/js/conduit',[ 'jclass', 'jquery' ], function( Class, $ ) {
	'use strict';

	/*
	===============================================================================
	Class: Conduit
	===============================================================================
	*/

	var Conduit = Class._extend( {

		/**
		 * Method: init
		 * @param {Object} aOptions
		 */

		init: function( aOptions ) {
			this._name = aOptions.name;
			this._parent = aOptions.parent;

			this._xhr = null;
			this._queue = [ ];
		},

		/**
		 * Method: getParent
		 */

		getParent: function( ) {
			return this._parent;
		},

		/**
		 * Method: ajax
		 * @param {Object} aOptions
		 */

		ajax: function( aOptions ) {
			var parent = this.getParent( ),
				opt = aOptions || { },
				before_callback, before_callback_interceptor,
				success_callback, success_callback_interceptor,
				error_callback, error_callback_interceptor,
				views, i, len, temp, tests,
				attempt = 0,
				jsonp = false,
				self = this;

			if ( opt.hasOwnProperty( 'showErrors' ) === false ) {
				opt.showErrors = true;
			}

			if ( opt.hasOwnProperty( 'dataType' ) === true && opt.dataType === 'jsonp' ) {
				opt.type = 'get';

				jsonp = true;
			}
			else {
				opt.type = 'post';
				opt.dataType = 'json';

				if ( opt.url.indexOf( '//' ) !== -1 ) {
					opt.url = opt.url.replace( '//', '' );
					opt.url = opt.url.substr( opt.url.indexOf( '/' ) );
				}

				views = parent.getDataViews( opt.url );

				if ( opt.hasOwnProperty( 'data' ) && opt.data !== null ) {
					if ( typeof opt.data === 'object' ) {
						if ( opt.data instanceof FormData ) {
							opt.data.append( '_system', false );

							if ( parent._csrf !== false ) {
								opt.data.append( parent._csrf.name, parent._csrf.value );
							}

							if ( parent._iframe !== false ) {
								opt.data.append( '_iframe', encodeURIComponent( parent._iframe ) );
							}

							if ( parent._version !== false ) {
								opt.data.append( '_version', parent._version );
							}

							for ( i = 0, len = views.length; i < len; i++ ) {
								opt.data.append( '_views[]', encodeURIComponent( views[ i ] ) );
							}
						}
						else {
							opt.data._system = false;
							opt.data._views = views;

							if ( parent._csrf !== false ) {
								opt.data[ parent._csrf.name ] = parent._csrf.value;
							}

							if ( parent._iframe !== false ) {
								opt.data[ '_iframe' ] = parent._iframe;
							}

							if ( parent._version !== false ) {
								opt.data[ '_version' ] = parent._version;
							}

							opt.data._ab = parent._ab;
						}
					}
					else if ( typeof opt.data === 'string' ) {
						opt.data += '&_system=false';

						if ( parent._csrf !== false ) {
							opt.data += '&' + parent._csrf.name + '=' + parent._csrf.value;
						}

						if ( parent._iframe !== false ) {
							opt.data += '&_iframe=' + encodeURIComponent( parent._iframe );
						}

						if ( parent._version !== false ) {
							opt.data += '&_version=' + parent._version;
						}

						for ( i = 0, len = views.length; i < len; i++ ) {
							opt.data += '&_views[]=' + encodeURIComponent( views[ i ] );
						}
					}
				}
				else {
					opt.data = {
						_system: false,
						_views: views
					};

					if ( parent._csrf !== false ) {
						opt.data[ parent._csrf.name ] = parent._csrf.value;
					}

					if ( parent._iframe !== false ) {
						opt.data[ '_iframe' ] = parent._iframe;
					}

					if ( parent._version !== false ) {
						opt.data[ '_version' ] = parent._version;
					}

					opt.data._ab = parent._ab;
				}
			}

			if ( opt.hasOwnProperty( 'error' ) === true && $.isFunction( opt.error ) === true ) {
				error_callback = opt.error;
			}
			else {
				error_callback = function( ) { };
			}

			if ( opt.hasOwnProperty( 'data' ) === true && opt.data.hasOwnProperty( '_ab' ) === true && opt.data._ab.length > 0 ) {
				// Copy _ab test states without the ui key (only of use to front-end)
				tests = [ ];

				for ( i = 0, len = opt.data._ab.length; i < len; i++ ) {
					temp = $.extend( true, { }, opt.data._ab[ i ] );

					delete temp.ui;

					tests.push( temp );
				}

				opt.data._ab = tests;
			}

			error_callback_interceptor = function( aXhr, aStatus, aError ) {
				if ( jsonp === false && aXhr.status === 404 ) {
					parent.load( aXhr.responseJSON );
				}
				else if ( jsonp === false && aXhr.status === 403 && attempt < 2 ) {
					attempt++;

					self._xhr = $.ajax( {
						url: '/token',
						type: 'get',
						dataType: 'json',
						beforeSend: function( ) {
							parent.verbose( 'app: access token expired' );
						},
						success: function( response ) {
							parent.verbose( 'app: updating access token' );

							if ( parent._csrf === false ) {
								parent._csrf = { };
							}

							parent._csrf.name = response.csrf.name;
							parent._csrf.value = response.csrf.value;

							if ( opt.data instanceof FormData ) {
								opt.data.delete( parent._csrf.name );
								opt.data.append( parent._csrf.name, parent._csrf.value );
							}
							else if ( typeof opt.data === 'string' ) {
								opt.data = opt.data.replace( '/&' + parent._csrf.name + '=[^&]+/', '&' + parent._csrf.name + '=' + parent._csrf.value );
							}
							else {
								opt.data[ parent._csrf.name ] = parent._csrf.value;
							}

							parent.verbose( 'app: resending failed request' );

							self._xhr = $.ajax( opt );
						}
					} );
				}
				else if ( aXhr.hasOwnProperty( 'statusText' ) === true && aXhr.statusText === 'abort' ) {
					parent.verbose( 'app: conduit ' + self._name + ' aborted' );

					return;
				}
				else {
					if ( aXhr.hasOwnProperty( 'readyState' ) === true ) {
						if ( parent._unloading === false ) {
							parent.verbose( 'app: fatal error' );

							if ( opt.showErrors !== false && parent._module !== null ) {
								parent._module.error( 'An error has occurred. ' + parent.getData( 'system.options.support_message' ) );
							}
						}
					}

					if ( parent._unloading === false ) {
						error_callback( aXhr, aStatus, aError );
					}
				}
			};

			opt.error = error_callback_interceptor;

			if ( opt.hasOwnProperty( 'beforeSend' ) === true && $.isFunction( opt.beforeSend ) === true ) {
				before_callback = opt.beforeSend;
			}
			else {
				before_callback = function( aXhr, aOptions ) { };
			}

			before_callback_interceptor = function( aXhr, aOptions ) {
				self.abort( );

				before_callback( aXhr, aOptions );
			};

			opt.beforeSend = before_callback_interceptor;

			if ( opt.hasOwnProperty( 'success' ) === true && $.isFunction( opt.success ) === true ) {
				success_callback = opt.success;
			}
			else {
				success_callback = function( aResponse, aCode, aXhr ) { };
			}

			success_callback_interceptor = function( aResponse, aCode, aXhr ) {
				if ( aResponse.hasOwnProperty( '_eventdata' ) === true ) {
					parent.events( aResponse._eventdata );

					delete aResponse._eventdata;
				}

				if ( aResponse.hasOwnProperty( '_logindata' ) === true ) {
					parent.login( aResponse._logindata );

					delete aResponse._logindata;
				}

				if ( aResponse.hasOwnProperty( 'status' ) && aResponse.status === false ) {
					if ( aResponse.hasOwnProperty( 'error' ) === true ) {
						error_callback( aResponse );
					}
					else if ( aResponse.hasOwnProperty( 'message' ) === true ) {
						parent.verbose( 'app: error' );

						if ( parent._module !== null && opt.showErrors !== false ) {
							parent._module.alert( {
								title: 'Warning',
								body: aResponse.message
							} );
						}

						error_callback_interceptor( aResponse );
					}
					else if ( aResponse.hasOwnProperty( 'validation' ) === true ) {
						parent.verbose( 'app: validation failed' );

						if ( opt.showErrors !== false ) {
							if ( typeof aResponse.validation === 'string' ) {
								parent.message( aResponse.validation, 'validation' );
							}
							else if ( typeof aResponse.validation === 'object' ) {
								parent.showFormErrors( aResponse.validation );
							}
						}

						error_callback_interceptor( aResponse );
					}
				}
				// Need to allow either string or object redirects
				else if ( aResponse.hasOwnProperty( 'redirect' ) === true && typeof aResponse.redirect === 'object' ) {
					parent.redirect( aResponse.redirect );
				}
				else {
					success_callback( aResponse, aCode, aXhr );
				}

				self.done( );
			};

			opt.success = success_callback_interceptor;

			this._xhr = $.ajax( opt );

			return this._xhr;
		},

		/**
		 * Method: queue
		 * @param {Object} aOptions
		 */

		queue: function( aOptions ) {
			var parent = this.getParent( ),
				options = aOptions || { },
				deferred, promise, i, len,
				duplicate = false,
				self = this;

			for ( i = 0, len = this._queue.length; i < len; i++ ) {
				if ( $.equal( options, this._queue[ i ].options ) === true ) {
					duplicate = true;

					break;
				}
			}

			if ( duplicate === false ) {
				deferred = $.Deferred( );

				promise = deferred.promise( );
				promise.success = promise.done;
				promise.error = promise.fail;
				promise.complete = promise.always;

				this.enqueue( {
					options: options,
					callback: function( ) {
						var xhr = self.ajax.apply( self, [ options ] );

						xhr.done( function( ) {
							deferred.resolve.apply( this, arguments );
						} );

						xhr.fail( function( ) {
							deferred.reject.apply( this, arguments );
						} );

						xhr.always( function( ) {
							self.dequeue( );
						} );

						return xhr;
					}
				} );

				return promise;
			}
			else {
				parent.verbose( 'app: duplicate queue entry found, skipping' );
			}

			return false;
		},

		/**
		 * Method: enqueue
		 * @param {Object} aRequest
		 */

		enqueue: function( aRequest ) {
			var request = aRequest || { },
				xhr;

			if ( this.running( ) === false ) {
				xhr = request.callback( );

				this._xhr = xhr;
			}
			else {
				this._queue.push( request );
			}
		},

		/**
		 * Method: dequeue
		 */

		dequeue: function( ) {
			var next, xhr;

			if ( this._queue.length > 0 ) {
				next = this._queue.shift( );

				xhr = next.callback( );

				this._xhr = xhr;
			}
			else {
				this._xhr = null;
			}
		},

		/**
		 * Method: done
		 */

		done: function( ) {
			this._xhr = null;
		},

		/**
		 * Method: running
		 * @return {Bool}
		 */

		running: function( ) {
			return ( this._xhr !== null );
		},

		/**
		 * Method: abort
		 */

		abort: function( ) {
			if ( this.running( ) === true ) {
				this._xhr.abort( );
				this._xhr = null;
			}
		},

		/**
		 * Method: clearQueue
		 */

		clearQueue: function( ) {
			this._queue = [ ];

			if ( this.running( ) === true ) {
				this.abort( );
			}
		}
	} );

	return Conduit;
} );

